// src/presentation/pages/ClinicalExamination/sections/AnxietySection.tsx
import React from "react";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { useTranslation } from "react-i18next";

interface AnxietySectionProps {
  value: string;
  onChange: (value: string) => void;
}

export const AnxietySection: React.FC<AnxietySectionProps> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation("patients");
  return (
    <div className=" border-gray-200">
      <div className="pb-3">
        <p className="text-sm text-gray-500">
          {t("clinicalSections.anxiety.question")}
        </p>
      </div>
      <div>
        <RadioGroup
          value={value}
          onValueChange={onChange}
          className="space-y-3"
        >
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="not-anxious" id="anxiety-not" />
            <Label
              htmlFor="anxiety-not"
              className="text-[#1B1D21] cursor-pointer text-sm font-normal"
            >
              {t("clinicalSections.anxiety.notAnxious")}
            </Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="moderately-anxious" id="anxiety-moderate" />
            <Label
              htmlFor="anxiety-moderate"
              className="text-[#1B1D21] cursor-pointer text-sm font-normal"
            >
              {t("clinicalSections.anxiety.moderatelyAnxious")}
            </Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="very-anxious" id="anxiety-very" />
            <Label
              htmlFor="anxiety-very"
              className="text-[#1B1D21] cursor-pointer text-sm font-normal"
            >
              {t("clinicalSections.anxiety.veryAnxious")}
            </Label>
          </div>
        </RadioGroup>
      </div>
    </div>
  );
};
